import React from 'react';
import { ErrorAlertConstellation } from '../ErrorAlert/ErrorAlertConstellation';

type ErrorBoundaryState = { hasError: true; error: Error } | { hasError: false; error: null };
const initialState: ErrorBoundaryState = { hasError: false, error: null };

// Generic ErrorBoundary. Must be used beneath a ConstellationThemeProvider
export class ErrorBoundaryConstellation extends React.Component<{ children: React.ReactNode }, ErrorBoundaryState> {
  constructor(props: { children: React.ReactNode }) {
    super(props);
    this.state = initialState;
  }
  static getDerivedStateFromError(caughtError: Error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error: caughtError };
  }

  render() {
    if (this.state.hasError) {
      return <ErrorAlertConstellation error={this.state.error} />;
    }
    return this.props.children;
  }
}
